import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useChannel = () => {
  const [channels, setChannels] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/channel/all')
        .then((response) => {
          setChannels(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [channels]
}

export default useChannel
